var SENTRY_RELEASE;SENTRY_RELEASE={name: "MintStint", version: "0.1.0"};